import { Injectable } from '@angular/core';
import { EnumScales, TimeRange } from '@library/store/measures/measures.interface';
import { LocalStorageService } from '@library/utils/services/local-storage.service';

const COMPARE_HEADER_CACHE_KEY = 'compare-header-cache-v1';

interface HeaderCache {
  scale: EnumScales;
  secondTimeRange: boolean;
}

@Injectable()
export class CpCompareHeaderCacheService {

  private cache: HeaderCache = JSON.parse(this.localStorage.getItem(COMPARE_HEADER_CACHE_KEY) ?? '{}');

  scale = this.cache.scale ?? null;
  secondTimeRange = this.cache.secondTimeRange ?? null;

  constructor(
    private localStorage: LocalStorageService,
  ) {}

  setScale(scale: EnumScales) {
    this.scale = scale;
    this.save();
  }

  setSecondTimeRange(secondTimeRange: TimeRange) {
    this.secondTimeRange = secondTimeRange ? true : false;
    this.save();
  }

  save() {
    this.localStorage.setItem(COMPARE_HEADER_CACHE_KEY, JSON.stringify({
      scale: this.scale,
      secondTimeRange: this.secondTimeRange,
    }));
  }

}